import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiDropdown, TuiButton } from '@taiga-ui/core';
import { SharedModule } from '@src/app/shared';
import { ComponentsModule } from '@src/app/components';
import { ThemeSwitcherModule } from '@src/app/modules/theme-switcher';
import { LanguageSwitcherModule } from '@src/app/modules/language-switcher';
import { InternalMessengerModule } from '@src/app/modules/internal-messenger';

import { TestingControlComponent } from './testing-control.component';

@NgModule({
  declarations: [TestingControlComponent],
  imports: [
    CommonModule,
    SharedModule,
    TuiButton,
    ...TuiDropdown,
    ThemeSwitcherModule,
    LanguageSwitcherModule,
    ComponentsModule,
    InternalMessengerModule,
  ],
  exports: [TestingControlComponent],
})
export class TestingControlModule {}
